import { HStack, Text } from "@chakra-ui/react";
import numeral from "numeral";
import React from "react";
import { NewBatteryLevelIndicator } from "../../indicators/NewBatteryLevelIndicator";

interface BatteryLevelProps {
  battery: number;
  isOffline?: boolean;
}

export const BatteryLevel = ({ battery, isOffline }: BatteryLevelProps) => {
  if (battery > 1) {
    battery = battery / 100;
  }
  const batteryText = numeral(battery).format("0[.]00%");
  return (
    <HStack alignItems="center">
      <NewBatteryLevelIndicator
        batteryLevel={battery}
        //  size={30}
        tooltipLabel={
          isOffline ? `Last Known Battery Level : ${batteryText}` : `Battery Level: ${batteryText}`
        }
        isOffline={isOffline}
      />
    </HStack>
  );
};
